"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var menu = [{
        id: 1,
        text: "工作台",
        icon: "icon-gongzuotai",
        path: "/",
        app: "portal"
    }, {
        id: 2,
        text: "消息",
        icon: "icon-xiaoxi",
        path: "/chat",
        app: "doctor"
    }, {
        id: 3,
        text: "患者",
        icon: "icon-huanzheguanli2",
        path: "/patient",
        app: "doctor"
    }, {
        id: 4,
        text: "文章",
        icon: "icon-wodewenzhang",
        path: "/article",
        app: "doctor"
    }, {
        id: 5,
        text: "表单",
        icon: "icon-biaodan",
        path: "/form",
        app: "doctor"
    }, {
        id: 6,
        text: "项目",
        icon: "icon-biaodan",
        path: "/xiangmu",
        app: "doctor"
    },
    //  {
    //     id: 7,
    //     text: "AI聊天记录",
    //     icon: "icon-biaodan",
    //     path: "/ai",
    //     app: "doctor"
    // },
    // {
    //     id: 8,
    //     text: "会话记录",
    //     icon: "icon-biaodan",
    //     path: "/chatDoctor",
    //     app: "doctor"
    // }
];
exports.default = menu;
